<template>
  <z-form ref="form" v-slot="{ invalid }" @submit.native.prevent="save">
    <transition name="fade" mode="out-in">
      <base-modal key="form">
        <template v-if="is_init">
          <template slot="description">
            {{ $t('db.recipient.modal.export.content') }}
          </template>
          <z-form-input :rules="{ min: 1, required: true }" :show_errors="false" mode="aggressive">
            <checkbox-group v-model="form.fields">
              <checkbox
                v-for="(label, key) in $t('db.recipient.field')"
                :key="key"
                :label="key"
                border
              >
                {{ label }}
              </checkbox>
            </checkbox-group>
          </z-form-input>
          <template slot="footer-ok">
            <i-button
              type="success"
              size="large"
              html-type="submit"
              :disabled="invalid"
              :loading="is_button_loading"
            >
              {{ $t('shared.component.button.confirm') }}
            </i-button>
          </template>
        </template>

        <template v-if="is_success" slot="description">
          <div>
            {{ $t('db.recipient.modal.export.success') }}
          </div>
        </template>
        <template v-if="is_error" slot="description">
          <div class="col-md-12 text-center mb-4">
            <icon type="ios-close-circle-outline" class="text-danger" size="165" />
          </div>
        </template>

        <template v-if="!is_init" #footer-cancel="{ close }">
          <i-button size="large" type="success" @click="close()">
            {{ $t('shared.component.button.ok') }}
          </i-button>
        </template>
      </base-modal>
    </transition>
  </z-form>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { RecipientService } from '@db/services/RecipientService';

  export default {
    components: {
      BaseModal
    },
    props: {
      database_id: {
        type: [Number, String],
        required: true
      }
    },
    data: () => ({
      state: '',
      states: {
        success: 'success',
        error: 'error'
      },
      form: {
        fields: []
      },
      is_button_loading: false
    }),
    computed: {
      is_init() {
        return !(this.is_success || this.is_error);
      },
      is_success() {
        return this.state === this.states.success;
      },
      is_error() {
        return this.state === this.states.error;
      }
    },
    methods: {
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;
            RecipientService.export(this.database_id, {
              columns: this.form.fields
            })
              .then(() => {
                this.state = this.states.success;
              })
              .catch(() => {
                this.state = this.states.error;
              })
              .finally(() => {
                this.is_button_loading = false;
              });
          }
        });
      }
    }
  };
</script>
